import Wrapper from "../../Wrapper";

 const AppointmentDesk = ()=>{
     return (
         <>
         <Wrapper>
            <h3 style={{textAlign: "center",position: "relative", top: "50px", color:"#bf2527"}}>Appointment Desk</h3>
         </Wrapper>
         </>
     );
 }
 export default AppointmentDesk;